import styled from 'styled-components';

import ImageTextBase from 'components/ImageText';

export const Container = styled.section`
  width: 100%;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.palette.primary.main};
  padding: 80px 14px;

  @media (max-width: ${({ theme }) => `${theme.screensSize.mobile}px`}) {
    padding: 40px 14px;
  }
`;

export const ImageText = styled(ImageTextBase)`
  ::-moz-selection {
    color: ${({ theme }) => theme.palette.primary.main};
    background: ${({ theme }) => theme.palette.mono.main};
  }

  ::selection {
    color: ${({ theme }) => theme.palette.primary.main};
    background: ${({ theme }) => theme.palette.mono.main};
  }
`;
